import { jsxs as d, jsx as a } from "react/jsx-runtime";
import p, { useEffect as u } from "react";
import r from "styled-components";
import { _ as y } from "../chunks/vendor_rango__tokens.38ee67b0.js";
import { RangoButtonIconHighlight as f, ButtonIconHighlightSize as m } from "./ButtonIconHighlight.js";
const z = r.div.withConfig({
  displayName: "CarouselNav",
  componentId: "sc-14a5d5z-0"
})(["display:flex;justify-content:space-between;align-items:center;width:100%;height:var(--size-8x);box-sizing:border-box;"]), w = r.div.withConfig({
  displayName: "Content",
  componentId: "sc-14a5d5z-1"
})(["", " color:var(--text-label-color);"], y), h = r.div.withConfig({
  displayName: "Actions",
  componentId: "sc-14a5d5z-2"
})(["display:flex;gap:var(--spacing-2x);"]), I = p.forwardRef(({
  children: n,
  prevButtonProps: g,
  nextButtonProps: v,
  active: e = 0,
  items: i = 0,
  showText: x = !0,
  onChange: o,
  ...N
}, b) => {
  const [t, l] = p.useState(e);
  u(() => {
    o == null || o(t);
  }, [t]), u(() => {
    l(e), o == null || o(e);
  }, [e]);
  const c = (s) => {
    s < 0 && t === 0 || s > 0 && t === i || l(t + s);
  };
  return /* @__PURE__ */ d(z, { ref: b, "data-testid": "rango-carousel-nav", "data-rango-component": "rango-carousel-nav", "data-is-rango": !0, ...N, children: [
    x && /* @__PURE__ */ a(w, { children: n || `Passo ${t}/${i}` }),
    /* @__PURE__ */ d(h, { children: [
      /* @__PURE__ */ a(f, { ...g, disabled: t === 1, size: m.LG, icon: "BackLine", onClick: () => c(-1) }),
      /* @__PURE__ */ a(f, { ...v, disabled: t === i, size: m.LG, icon: "GoLine", onClick: () => c(1) })
    ] })
  ] });
});
I.displayName = "RangoCarouselNav";
export {
  I as RangoCarouselNav
};
